import { gql } from './types/generated/gql';

export const GET_PARTNER_MAPPING = gql(`
  query getPartnerMapping {
    getAllChannels {
      name
      channels {
        id
        name
      }
    }
    getAllTargets {
      name
      targets {
        id
        name
        status
        type
        resourceTags {
          id
          name
        }
      }
    }
  }
`);

export const GET_CHANNEL = gql(`
  query getChannel($name: String!) {
    getChannel(name: $name) {
      id
      name
      targets {
        id
        type
      }
    }
  }
`);

export const GET_TARGET = gql(`
  query getTarget($name: String!) {
    getTarget(name: $name) {
      id
      name
      status
      type
      channelId
      resourceTags {
        id
        name
      }
    }
  }
`);
